import React from 'react';
import { ResponsiveContainer, AreaChart, Area, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

const AIPredictiveTrendWidget = ({ title, description, data, color = 'hsl(var(--primary))', suffix = '', variant = 'dark', valueFormatter }) => {
  const isLight = variant === 'light';
  const formatValue = (value) => {
    if (typeof valueFormatter === 'function') {
      return valueFormatter(value);
    }
    return `${value ?? 0}${suffix}`;
  };
  return (
    <Card className={isLight ? 'overflow-hidden rounded-2xl border border-border bg-card text-foreground shadow-sm' : 'overflow-hidden rounded-2xl border border-slate-700/80 bg-slate-950/90 text-slate-100 shadow-[0_16px_50px_rgba(2,6,23,0.3)] backdrop-blur-sm'}>
      <CardHeader className={isLight ? 'border-b border-border' : 'border-b border-slate-700/80'}>
        <CardTitle className={`text-base ${isLight ? 'text-foreground' : 'text-slate-50'}`}>{title}</CardTitle>
        <CardDescription className={isLight ? 'text-muted-foreground' : 'text-slate-300'}>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4 pt-5">
        <div className="flex items-end justify-between">
          <p className={`text-3xl font-semibold ${isLight ? 'text-foreground' : 'text-slate-50'}`}>{formatValue(data?.[data.length - 1]?.value ?? 0)}</p>
          <p className={`text-xs uppercase tracking-[0.18em] ${isLight ? 'text-muted-foreground' : 'text-slate-300'}`}>Forecast</p>
        </div>
        <div className="h-[180px]">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data || []}>
              <defs>
                <linearGradient id={`trend-${title}`} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={color} stopOpacity={0.45} />
                  <stop offset="100%" stopColor={color} stopOpacity={0.03} />
                </linearGradient>
              </defs>
              <CartesianGrid stroke={isLight ? 'rgba(148,163,184,0.2)' : 'rgba(255,255,255,0.08)'} vertical={false} />
              <XAxis dataKey="label" stroke={isLight ? '#64748b' : '#94a3b8'} tickLine={false} axisLine={false} />
              <YAxis stroke={isLight ? '#64748b' : '#94a3b8'} tickLine={false} axisLine={false} />
              <Tooltip
                formatter={(value) => formatValue(value)}
                contentStyle={{
                  backgroundColor: isLight ? '#ffffff' : '#020617',
                  border: isLight ? '1px solid rgba(226,232,240,1)' : '1px solid rgba(148,163,184,0.15)',
                  borderRadius: '14px',
                  color: isLight ? '#0f172a' : '#e2e8f0',
                }}
              />
              <Area type="monotone" dataKey="value" stroke={color} fill={`url(#trend-${title})`} strokeWidth={2.5} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default AIPredictiveTrendWidget;
